import React from "react";
import { ShieldCheck } from "lucide-react";
import { CERTS } from "@/i18n/translations";
import { useLang } from "@/context/LanguageContext";
import SmartImg from "@/components/SmartImg";

export default function CertBar({ dark = false }) {
  const { t } = useLang();
  return (
    <div className={dark ? "text-clara-text" : "text-ink"} data-testid="cert-bar">
      <div className="flex items-center gap-2 mb-6">
        <ShieldCheck size={16} className="text-claris-green" />
        <span className="text-[11px] uppercase tracking-[0.25em] font-semibold">{t("home.trustTitle")}</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-px bg-line/60 border border-line/60">
        {CERTS.map((c) => (
          <div
            key={c.abbr}
            data-testid={`cert-${c.abbr.toLowerCase()}`}
            className={`${dark ? "bg-clara-surface" : "bg-white"} px-5 py-8 flex flex-col items-center justify-center text-center gap-3 min-h-[150px]`}
          >
            {c.logo ? (
              <SmartImg src={c.logo} alt={c.name} className="h-16 md:h-20 w-auto object-contain" />
            ) : (
              <span className={`font-serif text-4xl md:text-5xl ${dark ? "text-clara-accent" : "text-claris"}`}>{c.abbr}</span>
            )}
            <span className={`text-[11px] uppercase tracking-wider ${dark ? "text-clara-text/60" : "text-inkmute"}`}>{c.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
